var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Grid, InputLabel, Typography } from '@mui/material';
import { CloudDownload } from '@mui/icons-material';
import { useFormik } from 'formik';
import { getCurrentUser } from '../localStorage';
import { useRequest } from '../hooks/requestHook';
import { useNotify } from '../hooks/notificationHook';
import { producer as api } from '../api';
import { FormikTextField } from './atoms/TextField';
import { camelize } from '../utils/camelize';
import PageSubmitButton from './molecules/PageSubmitButton';
import { FormikFileField } from './atoms/FileField';
import { FormikSingleCheckbox, toBooleanString, } from './atoms/SingleCheckbox';
import DownloadLink from './organisms/DownloadLink';
import { FormikAutocompleteSelectField } from './atoms/AutocompleteSelectField';
import { ProducerFieldFormats } from '../constants/fieldFormats';
var DownloadLinkWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  margin: 10px 20px;\n  text-align: center;\n\n  a {\n    color: inherit;\n    text-decoration: none;\n  }\n"], ["\n  display: inline-flex;\n  margin: 10px 20px;\n  text-align: center;\n\n  a {\n    color: inherit;\n    text-decoration: none;\n  }\n"])));
var REQUIRED_FIELDS = [
    'company',
    'firstname',
    'lastname',
    'country',
    'farmers_count',
    'phone',
    'address',
    'loading_port',
];
var ProducerEditForm = function (_a) {
    var producer = _a.producer, onUpdate = _a.onUpdate;
    var t = useTranslation().t;
    var countryMap = t('countries', { returnObjects: true });
    var countryItems = Object.entries(countryMap)
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        return ({
            text: value,
            value: key,
        });
    })
        .sort(function (a, b) { return a.text.localeCompare(b.text); });
    var currentUser = getCurrentUser();
    var notify = useNotify();
    var _b = React.useState(false), loading = _b[0], setLoading = _b[1];
    var updateProducer = useRequest(api.update);
    var onSubmit = React.useCallback(function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var formData, data, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    formData = new FormData();
                    Object.entries(values).forEach(function (_a) {
                        var key = _a[0], value = _a[1];
                        if (value instanceof File) {
                            formData.append("producer[".concat(key, "]"), value);
                        }
                        else {
                            formData.append("producer[".concat(key, "]"), "".concat(value));
                        }
                    });
                    data = {
                        id: producer.id,
                        producer: formData,
                    };
                    setLoading(true);
                    return [4 /*yield*/, updateProducer(data)];
                case 1:
                    response = _a.sent();
                    setLoading(false);
                    if (!response)
                        return [2 /*return*/];
                    onUpdate(response);
                    notify('success', [t('messages.updateSuccess')]);
                    return [2 /*return*/];
            }
        });
    }); }, [producer, onUpdate, notify, updateProducer, t]);
    var validate = React.useCallback(function (values) {
        var errors = {};
        REQUIRED_FIELDS.forEach(function (field) {
            if (values[field] === null ||
                values[field] === undefined ||
                values[field] === '') {
                errors[field] = t('errors.isRequired', {
                    field: t("params.producer.".concat(camelize(field))),
                });
            }
        });
        ProducerFieldFormats.forEach(function (_a) {
            var field = _a.field, regexp = _a.regexp, error = _a.error;
            var fieldAsKey = field;
            var value = values[fieldAsKey];
            if (value && !regexp.test(value)) {
                errors[fieldAsKey] = t("errors.".concat(error), {
                    field: t("params.producer.".concat(camelize(field))),
                });
            }
        });
        return errors;
    }, [t]);
    var initialValues = {
        company: producer.company,
        firstname: producer.firstname,
        lastname: producer.lastname,
        country: producer.country,
        farmers_count: producer.farmersCount,
        phone: producer.phone,
        address: producer.address,
        loading_port: producer.loadingPort,
        joined_in_okagesama_no_mori: toBooleanString(producer.joinedInOkagesamaNoMori) ||
            '0',
    };
    var formik = useFormik({
        initialValues: initialValues,
        onSubmit: onSubmit,
        validate: validate,
        validateOnChange: true,
        validateOnMount: true,
        enableReinitialize: true,
    });
    return (React.createElement("form", { onSubmit: formik.handleSubmit },
        React.createElement(Grid, { container: true, spacing: 4, style: { marginTop: 5 } },
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(FormikTextField, { variant: "outlined", label: t('params.producer.company'), name: "company", fullWidth: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(FormikTextField, { label: t('params.producer.firstname'), name: "firstname", fullWidth: true, required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(FormikTextField, { label: t('params.producer.lastname'), name: "lastname", fullWidth: true, required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(FormikAutocompleteSelectField, { name: "country", label: t('params.producer.country'), items: countryItems, fullWidth: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(FormikTextField, { label: t('params.producer.farmersCount'), name: "farmers_count", fullWidth: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(FormikTextField, { label: t('params.producer.phone'), name: "phone", fullWidth: true, required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(FormikTextField, { label: t('params.producer.address'), name: "address", fullWidth: true, required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(FormikTextField, { label: t('params.producer.loadingPort'), name: "loading_port", fullWidth: true, required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(FormikSingleCheckbox, { label: t('params.producer.joinInOkagesamaNoMori'), name: "joined_in_okagesama_no_mori", formik: formik, disabled: !producer.editableJoinedInOkagesamaNoMori }),
                !producer.editableJoinedInOkagesamaNoMori && (React.createElement("div", null,
                    React.createElement(Typography, { variant: "caption" }, t('labels.uneditableJoinedInOkagesamaNoMori'))))),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(InputLabel, null, t('params.producer.contract')),
                React.createElement(DownloadLinkWrapper, null, producer.contract ? (React.createElement(DownloadLink, { url: producer.contract.path, filename: producer.contract.filename },
                    React.createElement(CloudDownload, null),
                    React.createElement("div", null, producer.contract.filename))) : (React.createElement(Typography, { variant: "caption" }, t('labels.noData')))),
                currentUser.role === 'admin' && (React.createElement(FormikFileField, { name: "contract", label: t('labels.uploadContract'), formik: formik }))),
            React.createElement(Grid, { item: true, xs: 2 }),
            React.createElement(Grid, { item: true, xs: 8 },
                React.createElement(PageSubmitButton, { disabled: !formik.isValid || loading }, t('buttons.update'))),
            React.createElement(Grid, { item: true, xs: 2 }))));
};
export default ProducerEditForm;
var templateObject_1;
